import { Component, OnInit, OnDestroy, ViewChild, AfterViewInit } from '@angular/core';
import { MapComponent } from 'src/app/components/map/map.component';
import { ApplicationConfigService } from 'src/service/application-config.service';
import * as L from 'leaflet';

@Component({
  selector: 'app-fire-foresight-burn-list-map',
  templateUrl: './fire-foresight-burn-list-map.component.html',
  styleUrls: ['./fire-foresight-burn-list-map.component.css']
})
export class FireForesightBurnListMapComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('burnListMap', { read: MapComponent, static: false }) map: MapComponent;

  public mapHeight: number = 600;

  constructor(
    public app: ApplicationConfigService
  ) {}

  ngOnInit(): void {
    this.calculateMapHeight();
    window.addEventListener('resize', this.onResize);
  }

  ngAfterViewInit(): void {
    // Map initialization happens automatically in the MapComponent
    // We can listen for the mapInitComplete event if needed
    if (this.map) {
      console.log('Burn List Map initialized');
    }
  }

  ngOnDestroy(): void {
    window.removeEventListener('resize', this.onResize);
  }

  onMapInit(map: L.Map): void {
    console.log('Map initialized:', map);
    // Add any custom initialization here
  }

  private calculateMapHeight(): void {
    // Calculate height to fill available space
    // Subtract header/navbar heights as needed
    const windowHeight = window.innerHeight;
    const offset = 200; // Adjust based on your layout
    this.mapHeight = windowHeight - offset;
  }

  private onResize = (): void => {
    this.calculateMapHeight();
    if (this.map && this.map.map) {
      this.map.map.invalidateSize();
    }
  }
}
